export const POST_CONTROLLER_COMMANDS_FAILURE = "POST_CONTROLLER_COMMANDS_FAILURE";
export const POST_CONTROLLER_COMMANDS_REQUEST = "POST_CONTROLLER_COMMANDS_REQUEST";
export const POST_CONTROLLER_COMMANDS_SUCCESS = "POST_CONTROLLER_COMMANDS_SUCCESS";
